import { ActiveMenu } from './computeActiveMenu';

// Switching peersets refetches the dataset, so `peersets` is briefly undefined between the old and new
// value. During that gap the peerset fallback in computeActiveMenu can't match, clearing the highlight/
// open block for a frame (the flicker). Keep the last resolved active menu across that transient gap.
export const resolveStableActiveMenu = (
  computed: ActiveMenu,
  previous: ActiveMenu | null,
  hasPeersets: boolean
): ActiveMenu => {
  if (computed.selectedItem !== null) {
    return computed;
  }

  if (!hasPeersets && previous) {
    return previous;
  }

  return computed;
};
